import { Alert } from 'app/components/design-system-components'

const TenancyTransferAlert: React.FC = () => {
  return (
    <Alert
      variant="blueWithBg"
      showLeftIcon={true}
      leftIconVariant="info"
      mb={8}
    >
      A tenancy transfer will create a new off-market property and send an
      invitation to apply.
    </Alert>
  )
}

export default TenancyTransferAlert
